"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var ui_1 = require("../../ui");
var MyGrid = function (_a) {
    var cells = _a.cells, className = _a.className, spacing = _a.spacing;
    return (react_1["default"].createElement(ui_1.CellLayout, { className: className, spacing: spacing }, cells.map(function (cell, i) {
        var _a, _b, _c, _d, _e;
        return (react_1["default"].createElement(ui_1.Cell, { key: "simple-ui-cell-" + i + "-" + (cell.key || ''), xs: (_a = cell.width) === null || _a === void 0 ? void 0 : _a.xs, sm: (_b = cell.width) === null || _b === void 0 ? void 0 : _b.sm, md: (_c = cell.width) === null || _c === void 0 ? void 0 : _c.md, lg: (_d = cell.width) === null || _d === void 0 ? void 0 : _d.lg, xl: (_e = cell.width) === null || _e === void 0 ? void 0 : _e.xl, title: cell.title, description: cell.description, classNames: cell.classNames }, cell.Component));
    })));
};
exports["default"] = MyGrid;
